import './style.css'
import SceneCore from './Modules/SceneCore'
import STLayer from './Modules/Layers/STLayer'
import GridLayer from './Modules/Layers/GridLayer'
import NodeLayer from './Modules/Layers/NodeLayer/NodeLayer'
import DataParser from './Modules/Data/DataParser'
import Touch from './Modules/Touch/Touch'
import DetailLayer from './Modules/Layers/DetailLayer'
import PathLayer from './Modules/Layers/PathLayer'
import CSSLayer from './Modules/Layers/CSSLayer'

let currentState = 0
let currentStateExpandedNode = null
let nodeLayer = null
let detailLayer = null
let pathLayer = null
let dataManager = null
let touchManager = null

//INIT DATA INDEPENDENT LAYERS
//renderer, threejs scene, etc - includes grid variables: dimensions, number of squares, height
const sceneManager = new SceneCore()

//square hole, waves, s&t label
const spaceTimeLayer = new STLayer(sceneManager)

//2d isometric grid, navigation text (variables to resize are on the SceneManager class)
const gridLayer = new GridLayer(sceneManager)

//css tables (top dashboards, exploring data)
const cssLayer = new CSSLayer()


//LOAD DATA
const url = 'https://www.mecha.studio/sxt/assets/testdata.json';
getJSON(url, afterFetch);

function getJSON(url, callback) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.responseType = 'json';
    xhr.onload = function() {
      var status = xhr.status;
      if (status === 200) {
        callback(null, xhr.response);
      } else {
        callback(status, xhr.response);
      }
    };
    xhr.send();
};

//INIT DATA DEPENDENT LAYERS
function afterFetch(err, dataFetch) {
    if (err !== null) {
        console.log(err);
    } else {
    //data parser: creates BaseNode objects from json
    dataManager = new DataParser(dataFetch)

    //mouse tracking, touch/clicks
    touchManager = new Touch(sceneManager, dataManager)

    //downward lines, labels
    //nodelayer creates 3d representations of BaseNodes listed on the data class
    //nodelayer handles which 3d objects are on the raycasting target stack
    nodeLayer = new NodeLayer(sceneManager, dataManager, touchManager)

    //manages popup modal when inspecting node
    detailLayer = new DetailLayer(sceneManager)

    //draws paths connecting nodes
    pathLayer = new PathLayer(sceneManager, dataManager)

    gridLayer.showNavigationText() //delayed to wait for font load
    }
}

//Interaction State Machine, called by Touch.js
export function ChangeStateEvent(intersectNode) {
    if (!nodeLayer) return
    //STATE 0 - wide view, default
    if (currentState == 0) {
        if (!intersectNode) {
            return
        }
        if (intersectNode.type == 'blockchain' || intersectNode.type == 'major_project') {
            if (intersectNode.type == 'major_project') intersectNode = dataManager.blockChainNodes[intersectNode.parentBlockchainIndex]
            nodeLayer.hideAllNodes()
            nodeLayer.showExpandedView(intersectNode)
            pathLayer.showLinesExpanded(intersectNode)
            gridLayer.showNavigationText(intersectNode)
            gridLayer.showBackText()
            currentStateExpandedNode = intersectNode
            currentState = 1
            return
        }
        if (intersectNode.type == 'external_dataset') {
            nodeLayer.hideAllLabels()
            detailLayer.showPopup(intersectNode)
            currentStateExpandedNode = null
            currentState = 2
            return
        }
        if (intersectNode.type == 'customer_dapp') {
            nodeLayer.hideAllNodes()
            nodeLayer.showNode(intersectNode)
            if (intersectNode.parentBlockchainIndex != -1) nodeLayer.showNode(dataManager.blockChainNodes[intersectNode.parentBlockchainIndex])
            detailLayer.showPopup(intersectNode)
            pathLayer.showLinesClient(intersectNode)
            currentStateExpandedNode = null
            currentState = 2
            return
        }
    }
    //STATE 1 - expanded node view (only for networks)
    if (currentState == 1) {
        if (!intersectNode) {
            nodeLayer.showWideView()
            currentState = 0
            pathLayer.clearAllPaths()
            gridLayer.showNavigationText()
            gridLayer.hideBackText()
            return
        }
        if (intersectNode) {
            detailLayer.showPopup(intersectNode)
            nodeLayer.hideAllLabels()
            currentState = 2
            return
        }
    }
    //STATE 2 - detail view: showing pop-up
    if (currentState == 2) {
            if (!currentStateExpandedNode) {
                if (intersectNode) {
                    if (intersectNode.type == 'blockchain') {
                        detailLayer.hidePopup()
                        nodeLayer.hideAllNodes()
                        nodeLayer.showExpandedView(intersectNode)
                        pathLayer.clearAllPaths()
                        pathLayer.showLinesExpanded(intersectNode)
                        gridLayer.showNavigationText(intersectNode)
                        gridLayer.showBackText()
                        currentStateExpandedNode = intersectNode
                        currentState = 1
                        return
                    } 
                }
                nodeLayer.showWideView()
                detailLayer.hidePopup()
                currentState = 0
                pathLayer.clearAllPaths()
                return
            }
            if (currentStateExpandedNode) {
                nodeLayer.showExpandedView(currentStateExpandedNode)
                detailLayer.hidePopup()
                currentState = 1
                return
            }
        
    }
}

//show connecting lines from PathLayer.js when hovering over node (called from Touch.js)
export function HoverPath(hoverNode) {
    if (!nodeLayer) return
    if (currentState == 0) {
        if (!hoverNode) {
            pathLayer.clearHoverLine()
            return
        }
        if (hoverNode.type == 'customer_dapp') {
            pathLayer.showHoverLine(hoverNode)
        }
    }
}

